import React from "react";
import DebitCreditInterimReport from "../modules/DebitCreditInterimReport";

export default function DebitCreditInterimReportPage() {
    return <DebitCreditInterimReport/>
}